import { render, staticRenderFns } from "./RiskWeeklyTable.html?vue&type=template&id=9f4eb334&external"
import script from "./RiskWeeklyTable.vue?vue&type=script&lang=js"
export * from "./RiskWeeklyTable.vue?vue&type=script&lang=js"
import style0 from "./RiskWeeklyTable.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports